document.addEventListener("DOMContentLoaded", () => {
  const counterFields = document.querySelectorAll("[data-counter]");
  counterFields.forEach((field) => {
    const targetMaxLength = field.maxLength;
    if (!targetMaxLength) {
      return;
    }
    const helpText = field.insertAdjacentElement('afterend', document.createElement('p'));
    helpText.classList.add("help-block");
    helpText.textContent = window.interpolate(
      window.gettext("%(remaining)s characters remaining"),
      { remaining: targetMaxLength },
      true
    );

    field.addEventListener("input", (event) => {
      const targetLength = event.target.value.length;
      const remainingChars = targetMaxLength - targetLength;
      helpText.textContent = window.interpolate(
        window.gettext("%(remaining)s characters remaining"),
        { remaining: remainingChars },
        true
      );
      if (remainingChars <= 0) {
        helpText.classList.add("alert-warning");
      } else {
        helpText.classList.remove("alert-warning");
      }

    });
  });
});
